import { render, staticRenderFns } from "./broadcast.vue?vue&type=template&id=105b5a56&scoped=true"
import script from "./broadcast.vue?vue&type=script&lang=js"
export * from "./broadcast.vue?vue&type=script&lang=js"
import style0 from "./broadcast.vue?vue&type=style&index=0&id=105b5a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b5a56",
  null
  
)

export default component.exports